import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const UddyamaanUnnayan = ({ schemeType = 'uddyamaan' }) => {
  const navigate = useNavigate();
  const basePath = schemeType === 'protsaahan' ? '/protsaahan-yojana' : '/uddyamaan-unnayan-yojana';
  useEffect(() => { navigate(`${basePath}/dashboard`); }, [navigate, basePath]);
  return null;
};

export default UddyamaanUnnayan;
